import React from 'react';
import './App.css';
import Layout from './components/Layout/Layout';
import { initializeIcons } from '@fluentui/react';

initializeIcons('/static/fonts/');

function App() {
    return (
        <div className="App">
            <Layout></Layout>
        </div>
    );
}

export default App;
